var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tw-flex-between-center tw-gap-2 tw-bg-white tw-text-primary tw-py-8 tw-px-4 tw-rounded-t",
    on: {
      "click": _vm.clickHandler
    }
  }, [_c('div', {
    staticClass: "tw-flex-between-center tw-gap-2 tw-text-4"
  }, [_c('i', {
    class: [_vm.icon],
    style: {
      color: _vm.color
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-font-semibold"
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('i', {
    staticClass: "rtl:tw-hidden airalo-icon-arrow-right tw-text-3"
  }), _vm._v(" "), _c('i', {
    staticClass: "ltr:tw-hidden airalo-icon-arrow-left tw-text-3"
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }